import React from 'react';
import './Button.css';

interface ButtonProps {
  onClick?: () => void;
  onPointerDown?: (val: boolean) => void;
  onPointerUp?: (val: boolean) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  label?: string;
  isDisabled?: boolean;
  isHovering?: boolean;
  isClickable?: boolean;
  isSecondary?: boolean;
  size?: 'default' | 'small' | 'tiny';
  iconLeft?: React.ReactNode;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  label = '',
  isHovering = false,
  isDisabled = false,
  isClickable = true,
  isSecondary = false,
  size = 'default',
  onClick,
  onPointerDown,
  onPointerUp,
  onMouseEnter,
  onMouseLeave,
  iconLeft,
  icon,
  iconRight
}) => {

  const handleClick = () => {
    isClickable && onClick && onClick();
  }

  const handlePointerDown = () => {
    isClickable && onPointerDown && onPointerDown(true);
  }

  const handlePointerUp = () => {
    isClickable && onPointerUp && onPointerUp(false);
  }

  const handleMouseEnter = () => {
    onMouseEnter && onMouseEnter();
  };

  const handleMouseLeave = () => {
    onMouseLeave && onMouseLeave();
  };

  return (
    <button
      className={`
        ${isHovering ? 'isHovering' : ''} 
        ${isSecondary ? 'isSecondary' : ''} 
        ${isDisabled ? 'isDisabled' : ''} 
        ${isClickable ? 'isClickable' : ''}
        ${iconLeft ? 'icon left' : ''}
        ${icon ? 'icon' : ''}
        ${iconRight ? 'icon right' : ''}
        ${size}
      `}
      onClick={handleClick}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
    {/* <ion-spinner *ngIf="isLeftSpinner; else showIconLeft" class="spinner left" name="crescent"></ion-spinner> */}
    {iconLeft && <span className="icon left">{iconLeft}</span>}
    <span className="label">{ label }</span>
    {icon && <span className="icon">{icon}</span>}

    {iconRight && <span className="icon right">{iconRight}</span>}
  </button>
  );
};

export default Button;
